<aurora-toggle
  class="{{ classes }}"
  [attr.id]="inputId"
  [label]="label"
  [checked]="isChecked"
  [disabled]="disabled"
  (change)="onCheckboxChange($event)"
></aurora-toggle>